var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#007AFF",
  d: "m8.29 24-2.072-3.657-3.927-.914.382-4.229L0 12l2.673-3.2-.382-4.229 3.927-.914L8.291 0 12 1.657 15.71 0l2.072 3.657 3.927.914-.382 4.229L24 12l-2.673 3.2.382 4.229-3.927.914L15.709 24 12 22.343zm2.565-7.943L17.018 9.6l-1.527-1.657-4.636 4.857-2.346-2.4L6.982 12z"
})));
export default SvgCheck;